import { createContext } from 'react';
import { DocumentCompareActionType, DocumentCompareState } from './types';

export const DocumentCompareContext = createContext<{
    state: DocumentCompareState;
    dispatch: React.Dispatch<DocumentCompareActionType>;
} | undefined>(undefined);
